import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'attendeeStats';
export const actionTypes = {
  FETCH_ATTENDEE_STATS: `${FEATURE_NAME}/FETCH_ATTENDEE_STATS`
} satisfies ActionTypes<typeof FEATURE_NAME>;
    